<template lang="pug">
div(:class="currentView == 'chart' ? '': 'chartWrapper'")
    Button.cardBtn.textBtn(@click="toggleCurrentView" v-if="showRawBtnStyle == 'textBtn' && withRawBtn") {{ toggleViewHint }}
    Button.iconBtn( @click="toggleCurrentView" v-if="showRawBtnStyle == 'iconBtn' && withRawBtn" :icon="toggleViewHint")
    template(v-if="withCard")
        template(v-if="currentView == 'chart'")
            Card.card-shadow
                line-chart(
                    :chart-data="chartData.datacollection"
                    :options="chartData.options"
                    :width="chartWidth"
                    :height="chartHeight"
                )
        template(v-else)
            Table(:class="tableHeaderStyle" :columns="rawDataTableColumns" :data="rawDataTableData" :style="{height: chartHeight,'overflow-y': 'scroll'}")
    template(v-else)
        template(v-if="currentView == 'chart'")
            line-chart(
                :chart-data="chartData.datacollection"
                :options="chartData.options"
                :width="chartWidth"
                :height="chartHeight"
            )
        template(v-else)
            Table(
                :class="tableHeaderStyle"
                :columns="rawDataTableColumns"
                :data="rawDataTableData"
                :no-data-text="$t('main.tableNoDataText')"
                :style="{height: chartHeight,'overflow-y': 'scroll'}"
            )
    Spin(size="large" fix v-if="spinShow")
</template>
<script>
import Chart from "chart.js";
import bus from "@/libs/bus.js";

import LineChart from "@/components/lineChart.js";
import { getEdgeChartData } from "@/api/monitor.js";
import { bytesToSpeed } from "@/libs/numeralextend.js";

import numeral from "numeral";
import moment from "moment";
// load a format
numeral.register("format", "bytesToSpeed", {
    regexps: {
        format: /(bps)/,
        unformat: /(bps)/,
    },
    format: function (value) {
        var output = bytesToSpeed(value);
        return output;
    },
});

// use your custom format
// numeral().format("0%");
import { xAxesTimeFormat } from "@/libs/xAxesTimeFormat";

const verticalLinePlugin = {
    afterDraw: function (chart) {
        const opts = chart.config.options || {};
        const lines = opts.verticalLines || [];
        if (!lines.length) return;

        const xScale = chart.scales["x-axis-0"];
        const chartArea = chart.chartArea;
        const ctx = chart.chart.ctx;

        ctx.save();

        lines.forEach((value, i) => {
            const x = xScale.getPixelForValue(value);
            if (isNaN(x) || x < chartArea.left || x > chartArea.right) return;

            const color = opts.verticalLineColors[i] || "rgba(200,0,0,0.7)";
            const width = opts.verticalLineWidths[i] || 1.5;
            const dash = opts.verticalLineDashes[i] || [6, 6];

            if (ctx.setLineDash) ctx.setLineDash(dash);
            ctx.lineWidth = width;
            ctx.strokeStyle = color;

            ctx.beginPath();
            ctx.moveTo(x, chartArea.top);
            ctx.lineTo(x, chartArea.bottom);
            ctx.stroke();
        });

        ctx.restore();
    },
};

// 這段一定要有，plugin 才會被用到
if (Chart && Chart.plugins && !Chart.plugins._verticalLineRegistered) {
    Chart.plugins.register(verticalLinePlugin);
    Chart.plugins._verticalLineRegistered = true; // 避免熱重載重複註冊
}

export default {
    name: "LineChartWrapper",
    props: {
        chartType: { type: String, default: "" },
        chartTitle: { type: String, default: "" },
        titleDisplay: { type: Boolean, default: true },
        chartDataSetLabel: { type: Array, default: () => [] },
        chartDataSetLabelTranslate: { type: Boolean, default: true },
        numeralFormat: { type: String, default: "0a" },
        numeralFormatTooltips: { type: String, default: "" },
        numeralFormatYAxes: { type: String, default: "" },
        numeralFormatFunction: { default: "" },

        groupNames: { type: Array, default: () => [] },
        tags: { type: Array, default: () => [] },
        serviceGroupNames: { type: Array, default: () => [] },
        domains: { type: Array, default: () => [] },
        appProfileNames: { type: Array, default: () => [] },
        tags: { type: Array, default: () => [] },
        origins: { type: Array, default: () => [] },
        originHosts: { type: Array, default: () => [] },
        originPorts: { type: Array, default: () => [] },
        latencyStatusNames: { type: Array, default: () => [] },
        edgeNames: { type: Array, default: () => [] },
        slbNames: { type: Array, default: () => [] },
        netflowIps: { type: Array, default: () => [] },
        dateRange: { type: String, default: "" },
        customTimeRange: { type: Array, default: () => [] },

        withCard: { type: Boolean, default: true },
        withPropRawBtn: {},
        chartWidth: { type: Number, default: 600 },
        chartHeight: { type: Number, default: 340 },
        xAxesDisplay: { type: Boolean, default: true },
        yAxesDisplay: { type: Boolean, default: true },
        xAxesGridlineDisplay: { type: Boolean, default: true },
        yAxesGridlineDisplay: { type: Boolean, default: true },
        legendDisplay: { type: Boolean, default: true },
        legendLabelUsePointStyle: { type: Boolean, default: false },
        legendPosition: { type: String, default: "top" },
        legendAlign: { type: String, default: "center" },

        // border, 背景色, 漸層背景色
        lineBorderColors: { type: Array, default: () => [] },
        lineBackgroundColors: { type: Array, default: () => [] },
        lineBackgroundGradientStops: { type: Array, default: () => [] },

        // 線的配置
        borderWidth: { type: Array, default: () => [3] },
        lineTension: { type: Array, default: () => [0.5] },

        // 線的點點配置
        linePointRadius: { type: Array, default: () => [0] },
        linePointBackgroundColor: {
            type: Array,
            default: () => ["rgba(0, 0, 0, 0.1)"],
        },
        linePointBorderWidth: { type: Array, default: () => [1] },
        linePointHoverRadius: { type: Array, default: () => [1] },
        linePointHoverBorderWidth: { type: Array, default: () => [1] },
        linePointHoverBorderColor: { type: Array, default: () => ["white"] },
        linePointHoverBackgroundColor: {
            type: Array,
            default: () => ["white"],
        },

        // 是否使用後台dataset label, 無固定數組時使用
        // 如不使用則引用前台定義的chartDataSetLabel
        useBackendDatasetLabel: { type: Boolean, default: false },

        apiEndpoint: { type: String, default: "" },
        isGetDataFromStore: { type: Boolean, default: false },
        isPointStyle: { type: Boolean, default: false },
        healthCheckMode: { type: Array, default: () => [] },

        // 從父組件傳送圖表內容
        initData: { type: Object, default: () => {} },

        // 是否固定 Y 軸
        yAxisMax: { type: Number, default: undefined }, // undefined = 走 Chart.js 預設

        // 是否自動調整 label 顯示數量
        xAxisAutoSkip: { type: Boolean, default: undefined },
        xAxisMaxTicksLimit: { type: Number, default: undefined },

        // 預設隱藏的 label
        hiddenSeries: { type: Array, default: () => [] },

        // 垂直虛線設定（多條可不同顏色）
        verticalLines: { type: Array, default: () => [] }, // [timestamp1, timestamp2, ...]
        verticalLineColors: { type: Array, default: () => [] }, // ['red', 'green', ...]
        verticalLineWidths: { type: Array, default: () => [] }, // [1.5, 2, ...]
        verticalLineDashes: { type: Array, default: () => [] }, // [[6,6], [10,5], ...]
    },
    components: { LineChart },
    watch: {
        "$store.state.userPref.lang": function (newVal, oldVal) {
            this.fillChartData(this.nginxData);
        },
    },
    created() {},
    beforeDestroy() {
        bus.$off("searchChartData", this.getDataAndDraw);
    },
    data() {
        return {
            spinShow: false,
            chartData: {
                datacollection: {},
                options: {},
            },
            nginxData: null,
            rawDataTableData: [],
            rawDataTableColumns: [],
            currentView: "chart",
            dateRangeMap: {
                0: {
                    unit: "YYYY-MM-DD H:mm:ss",
                },
                1: {
                    unit: "YYYY-MM-DD H:mm",
                },
                2: {
                    unit: "YYYY-MM-DD H:mm",
                },
                3: {
                    unit: "YYYY-MM-DD H:mm",
                },
                4: {
                    unit: "YYYY-MM-DD H:mm",
                },
                5: {
                    unit: "YYYY-MM-DD H:00",
                },
                6: {
                    unit: "YYYY-MM-DD H:mm:ss",
                },
                // case 7 為 last_month
                7: {
                    unit: "YYYY-MM-DD",
                },
                // case 8 為 this_month
                8: {
                    unit: "YYYY-MM-DD"
                },
                99: {
                    unit: "YYYY-MM-DD",
                },
            },
            emitDataValue: {},
        };
    },
    methods: {
        fillChartData(nginxData) {
            var self = this;
            var canvas, ctx;
            var gradientColors = [];
            if (this.lineBackgroundGradientStops.length > 0) {
                canvas = document.getElementById("custom-line");
                ctx = canvas.getContext("2d");

                gradientColors = this.lineBackgroundGradientStops.map((gradientStops) => {
                    let gradient = ctx.createLinearGradient(0, 0, 0, this.chartHeight);
                    gradientStops.forEach((stop, index) => {
                        gradient.addColorStop(index, stop);
                    });
                    return gradient;
                });
            }

            var datasets = nginxData.data.datasets.map((dataset, index) => {
                return {
                    label: this.useBackendDatasetLabel
                        ? this.legendDisplayFormatter(dataset.label)
                        : this.chartDataSetLabelTranslate
                        ? this.legendDisplayFormatter(this.$i18n.t(this.chartDataSetLabel[index]))
                        : this.legendDisplayFormatter(this.chartDataSetLabel[index]),
                    data: dataset.data,
                    lineTension: this.lineTension[index],
                    pointRadius: this.isPointStyle == true ? this.linePointRadius[index] : 0,
                    pointBorderWidth: this.linePointBorderWidth[index],
                    pointBackgroundColor: this.linePointBackgroundColor[index],

                    pointHoverRadius: 1,
                    pointHoverBorderWidth: this.linePointHoverBorderWidth[index],
                    pointHoverBorderColor: this.linePointHoverBorderColor[index],
                    pointHoverBackgroundColor: this.linePointHoverBackgroundColor[index],

                    backgroundColor: this.lineBackgroundColors[index] || gradientColors[index],
                    borderColor: this.lineBorderColors[index],
                    borderWidth: this.borderWidth[index],
                    fill: this.lineBackgroundColors.length > 0 || this.lineBackgroundGradientStops.length > 0,

                    hidden: this.hiddenSeries.includes(dataset.label),
                };
            });

            // 調整圖表 legend為 方形或圓形
            let legendLabel = {};
            if (this.isPointStyle == true) {
                legendLabel = {
                    usePointStyle: true,
                    boxWidth: 8,
                    generateLabels: function (chart) {
                        let labels = Chart.defaults.global.legend.labels.generateLabels(chart);
                        labels = labels.map((label) => {
                            label.fillStyle = self.lineBorderColors[label.datasetIndex];
                            return label;
                        });
                        return labels;
                    },
                };
            }

            var chartData = {
                datacollection: {
                    labels: nginxData.data.labels,
                    datasets: datasets,
                },
                options: {
                    // 給 plugin 用的參數（關鍵！）
                    verticalLines: this.verticalLines,
                    verticalLineColors: this.verticalLineColors,
                    verticalLineWidths: this.verticalLineWidths,
                    verticalLineDashes: this.verticalLineDashes,
                    title: {
                        display: this.titleDisplay,
                        text: this.chartTitle,
                    },
                    legend: {
                        display: this.legendDisplay,
                        // onClick: null,
                        labels: legendLabel,
                        position: this.legendPosition,
                        align: this.legendAlign,
                        maxWidth: 20,
                        fullSize: false,
                        maxHeight: 20,
                        // onHover: (event, legendItem, legend) => {
                        //     console.log(event, legendItem, legend);
                        // }
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    hover: {
                        mode: "index",
                        intersect: false,
                    },
                    tooltips: {
                        mode: "index",
                        intersect: false,
                        position: "custom",
                        caretSize: 0,
                        callbacks: {
                            label: function (tooltipItem, data) {
                                var label = nginxData.data.datasets[tooltipItem.datasetIndex].label || "";
                                if (label) {
                                    label += ": ";
                                }

                                label += numeral(tooltipItem.yLabel).format(
                                    self.numeralFormatTooltips ? self.numeralFormatTooltips : self.numeralFormat
                                );
                                return label;
                            },
                            labelColor: function (tooltipItem, chart) {
                                return {
                                    borderColor: self.lineBorderColors[tooltipItem.datasetIndex],
                                    backgroundColor: self.lineBorderColors[tooltipItem.datasetIndex],
                                };
                            },
                        },
                    },
                    scales: {
                        xAxes: [
                            {
                                display: this.xAxesDisplay,
                                type: "time",
                                time: xAxesTimeFormat(this.queryFilter.dateRangeOptions.index),
                                gridLines: {
                                    display: this.xAxesGridlineDisplay,
                                },
                                ticks: {
                                    autoSkip: this.xAxisAutoSkip,
                                    maxTicksLimit: this.xAxisMaxTicksLimit,
                                },
                            },
                        ],
                        yAxes: [
                            {
                                display: this.yAxesDisplay,
                                ticks: {
                                    max: this.yAxisMax,
                                    callback: function (num, index, values) {
                                        return numeral(num).format(
                                            self.numeralFormatYAxes ? self.numeralFormatYAxes : self.numeralFormat
                                        );
                                    },
                                    min: 0,
                                    maxTicksLimit: 6,
                                },
                                gridLines: {
                                    display: this.yAxesGridlineDisplay,
                                    color: "#f0f0f0",
                                },
                            },
                        ],
                    },
                },
            };

            this.chartData = chartData;
            this.columnDataToTableData();
        },
        getNginxData() {
            this.spinShow = true;

            var chartOptions = {
                chartType: this.chartType,
                groupNames: this.queryFilter.groupNames,
                tags: this.queryFilter.tags,
                serviceGroupNames: this.queryFilter.serviceGroupNames,
                domains: this.queryFilter.domains,
                appProfileNames: this.queryFilter.appProfileNames,
                tags: this.queryFilter.tags,
                origins: this.queryFilter.origins,
                originHosts: this.queryFilter.originHosts,
                originPorts: this.queryFilter.originPorts,
                slbNames: this.queryFilter.slbNames,
                edgeNames: this.queryFilter.edgeNames,
                netflowIps: this.queryFilter.netflowIps,
                latencyStatusNames: this.queryFilter.latencyStatusNames,
                dateRangeOptions: {
                    index: this.queryFilter.dateRangeOptions.index,
                    customTimeRange: this.queryFilter.dateRangeOptions.customTimeRange,
                },
                apiEndpoint: this.apiEndpoint,
                healthCheckMode: this.healthCheckMode,
            };

            return getEdgeChartData(chartOptions).then((res) => {
                this.$emit("getEdgeChartData", { [chartOptions.chartType]: true });
                return res;
            });
        },
        getDataAndDraw() {
            this.getNginxData().then((nginxData) => {
                //如果是用原本的圖表（非sampling）獲取回來的資料就存到store，以利後續使用
                if (this.isGetDataFromStore) {
                    this.$store.commit("SET_CHART_DATA", { chartName: this.chartType, data: nginxData.data });
                }
                this.nginxData = nginxData;
                this.fillChartData(nginxData);
                this.spinShow = false;
            });
        },
        toggleCurrentView() {
            if (this.currentView == "chart") {
                this.currentView = "rawDataTable";
                this.columnDataToTableData();
            } else {
                this.currentView = "chart";
            }
        },
        columnDataToTableData() {
            this.rawDataTableData = [];
            // var data = this.chartData.datacollection;
            var data = this.nginxData.data;
            this.rawDataTableColumns = data.datasets.map((dataset) => {
                return {
                    title: dataset.label,
                    key: dataset.label,
                    minWidth: 200,
                };
            });
            this.rawDataTableColumns.unshift({
                title: "Date",
                key: "date",
                minWidth: 200,
            });

            var unitFormat = this.dateRangeMap[this.queryFilter.dateRangeOptions.index].unit;

            var unit = data.labels ? data.labels.length - 1 : 0;

            var unitArray = [];

            //把轉換成每行的資料總合存在dataArray裡 所以會是一個長度為後台回傳點的長度的array
            data.datasets.forEach((o) => {
                o.dataArray = [];
                for (var i = 0; i < unit + 1; i++) {
                    o.dataArray.push(
                        o.data.slice(i, i + 1).reduce(function (prev, ele) {
                            return prev + ele;
                        }, 0)
                    );
                }
            });

            for (var i = 0; i < unit; i++) {
                //每幾筆資料就切成一個array（依照後台定義） 取每個array的第一個值來轉換成日期 存到dayArray裡
                unitArray.push(moment(data.labels.slice(i, i + 1)[0]).format(unitFormat));

                //把轉換好的資料轉成table data  預期的格式會是陣列包以下的 object
                // { date : '2020/06/20' , dataCached : 50MB , dataServed: 7GB}
                // { data : '2020/06/20' , Request : 31.3m }
                var tableObject = {};
                tableObject = {
                    date: unitArray[i],
                };
                // chartDatasetLabel 是每條線的名稱 ex: dataCached,dataServed / Request / speed_limitation
                var chartDataSetLabel = data.datasets.map((e) => e.label);
                chartDataSetLabel.forEach((obj, idx) => {
                    tableObject[obj] = numeral(data.datasets[idx].dataArray[i]).format(this.numeralFormat);
                });
                this.rawDataTableData.push(tableObject);
            }

            // emit raw data to parent component (NetflowAnalyze.vue) for exporting PDF and CSV
            if (this.chartType == "byteincominglinechart" || this.chartType == "byteoutgoinglinechart") {
                this.emitDataValue = {
                    data: this.rawDataTableData,
                };
                this.emitData();
            }
        },
        legendDisplayFormatter(name) {
            let formatName = name.substr(0, 8) + "...";
            return name.length > 8 && this.legendPosition == "right" ? formatName : name;
        },
        emitData() {
            this.$emit("emitData", { chartType: this.chartType, data: this.emitDataValue });
        },
        // 設定資料並且畫圖
        setDataAndDraw(){
            this.nginxData = this.initData;
            this.fillChartData(this.nginxData);
        }
    },
    mounted() {
        if (this.initData) {
            // 有初始資料，直接建構圖表
            this.setDataAndDraw()
        } else {
            // 無初始資料，先取得資料再建構圖表
            this.getDataAndDraw();
        }

        bus.$on("searchChartData", this.getDataAndDraw);
        bus.$on("setDataAndDraw", this.setDataAndDraw);
    },
    computed: {
        tableHeaderStyle() {
            return this.$store.getters.getTableConfig.headerStyle;
        },
        showRawBtnStyle() {
            return this.$store.getters.getChartConfig.showRawBtnStyle;
        },
        withRawBtn() {
            // no button for chart in NetflowAnalyze.vue
            if (this.apiEndpoint == "/monitor/netflowchartdata") {
                return false;
            }

            return this.withPropRawBtn !== undefined
                ? this.withPropRawBtn
                : this.$store.getters.getChartConfig.withRawBtn;
        },
        toggleViewHint() {
            if (this.showRawBtnStyle == "textBtn") return this.currentView == "chart" ? "View Raw" : "Back To Chart";
            return this.currentView == "chart" ? "md-eye" : "md-redo";
        },
        // query 參數, 優先使用props, 否則去看store
        queryFilter() {
            var queryFilter = this.$store.state.dashboard.queryFilter;

            // 如果dashboardQueryFilter組件還沒生成, 那就先看store > queryGroupName
            var queryGroupName = this.$store.state.queryGroupName;
            return {
                groupNames:
                    this.groupNames.length > 0
                        ? this.groupNames
                        : queryGroupName !== "all"
                        ? [queryGroupName]
                        : queryFilter.groupNames,
                tags: this.tags.length > 0 ? this.tags : queryFilter.tags,
                serviceGroupNames:
                    this.serviceGroupNames.length > 0 ? this.serviceGroupNames : queryFilter.serviceGroupNames,
                domains: this.domains.length > 0 ? this.domains : queryFilter.serverNames,
                appProfileNames: this.appProfileNames.length > 0 ? this.appProfileNames : queryFilter.appProfileNames,
                tags: this.tags.length > 0 ? this.tags : queryFilter.tags,
                origins: this.origins.length > 0 ? this.origins : queryFilter.origins,
                originHosts: this.originHosts.length > 0 ? this.originHosts : queryFilter.originHosts,
                originPorts: this.originPorts.length > 0 ? this.originPorts : queryFilter.originPorts,
                slbNames: this.slbNames.length > 0 ? this.slbNames : queryFilter.slbNames,
                edgeNames: this.edgeNames.length > 0 ? this.edgeNames : queryFilter.edgeNames,
                netflowIps: this.netflowIps.length > 0 ? this.netflowIps : queryFilter.netflowIps,
                latencyStatusNames:
                    this.latencyStatusNames.length > 0 ? this.latencyStatusNames : queryFilter.latencyStatusNames,
                dateRangeOptions: {
                    index: this.dateRange || queryFilter.dateRangeOptions.index,
                    customTimeRange:
                        this.customTimeRange.length > 0
                            ? customTimeRange
                            : queryFilter.dateRangeOptions.customTimeRange,
                },
            };
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/LineChartWrapper.vue